import TableChartIcon from "@mui/icons-material/TableChart";

import { makeSvgIcon } from "./svg-icon";

export const DataIcon = makeSvgIcon(
  TableChartIcon,
  (theme) => theme.palette.data.main,
);

export default DataIcon;
